<template>
  <div class="wrapper">
    <div class="page-header page-header-small">
      <parallax class="page-header-image" style="background-image: url('img/salud/07.jpg')"></parallax>
    </div>

    <div class="section">
      <div class="main">
        <div class="contact-content">
          <div class="container">
            <div class="row">
              <div class="col-md-5 ml-auto mr-auto">
                <h2 class="title">Envianos un mensaje</h2>
                <!-- <p class="description">
                  ACA VA EL TEXTO DE ENCABEZADO DEL FORMULARIO
                  <br>
                  <br>
                </p>-->
                <form role="form" id="contact-form">
                  <label>Nombre Completo</label>
                  <fg-input
                    v-validate="'required'"
                    name="nombre"
                    placeholder="Su nombre..."
                    v-model="form.nombre"
                    addon-left-icon="now-ui-icons users_circle-08"
                  ></fg-input>
                  <span
                    v-show="errors.has('nombre')"
                    class="error-message"
                  >{{ errors.first('nombre') }}</span>

                  <label>Email</label>
                  <fg-input
                    v-validate="'required|email'"
                    name="email"
                    placeholder="Email..."
                    v-model="form.email"
                    addon-left-icon="now-ui-icons users_circle-08"
                  ></fg-input>
                  <span
                    v-show="errors.has('email')"
                    class="error-message"
                  >{{ errors.first('email') }}</span>

                  <label>Teléfono</label>

                  <fg-input
                    v-validate="'required'"
                    name="telefono"
                    placeholder="Número aquí..."
                    v-model="form.telefono"
                    addon-left-icon="now-ui-icons tech_mobile"
                  ></fg-input>
                  <span
                    v-show="errors.has('telefono')"
                    class="error-message"
                  >{{ errors.first('telefono') }}</span>

                  <div class="form-group">
                    <label>Motivo</label>
                    <fg-input class>
                      <el-select
                        class="select-default"
                        v-model="form.condicionId"
                        ref="condicionContactoSelect"
                      >
                        <el-option
                          v-for="item in condicionContactoList"
                          :value="item.Value"
                          :label="item.Text"
                          :key="item.Value"
                        ></el-option>
                      </el-select>
                    </fg-input>
                  </div>

                  <label>Empresa u Organización</label>
                  <fg-input
                    placeholder="Su empresa u organización..."
                    name="empresa"
                    v-model="form.empresa"                    
                    addon-left-icon="now-ui-icons users_circle-08"
                  ></fg-input>
                  <span
                    v-show="errors.has('empresa')"
                    class="error-message"
                  >{{ errors.first('empresa') }}</span>

                  <div class="form-group">
                    <label>Su mensaje</label>
                    <textarea
                      v-validate="'required'"
                      v-model="form.mensaje"
                      name="mensaje"
                      class="form-control"
                      id="message"
                      rows="6"
                    ></textarea>
                    <span
                      v-show="errors.has('mensaje')"
                      class="error-message"
                    >{{ errors.first('mensaje') }}</span>
                  </div>
                  <div class="form-group">
                    <vue-recaptcha :sitekey="captchaKey" @verify="onVerify" v-show="!verified"></vue-recaptcha>
                  </div>
                  <div class="submit text-center">
                    <input                      
                      type="button"
                      @click="sendForm"
                      class="btn btn-primary"
                      round
                      value="Enviar"
                    />
                  </div>
                </form>
              </div>
              <div class="col-md-5 ml-auto mr-auto">
                <info-section type="primary" class="mt-5" icon="now-ui-icons location_pin">
                   <a href="#/oficinas"><h4 class="info-title">Encuentranos en nuestras oficinas</h4></a>
                  <!--<h4 class="info-title">Encuentranos en nuestra oficina</h4>
                  <p>
                    <a href="#/oficinas">Av. Avellaneda 2144</a>,
                    <br />C1406FYT,
                    <br />CABA
                  </p>
                  -->
                </info-section>

                <info-section type="primary" icon="now-ui-icons tech_mobile">
                  <h4 class="info-title">Llámenos</h4>
                  <p>
                    Atención al afiliado
                    <br />
                    <br />0800 666 7276
                  </p>

                  <p>
                    Más telefonos útiles
                    <br />
                    <a href="#/telefonos">Click aquí</a>
                  </p>
                </info-section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isSuccessHidden" class="alert alert-success" role="alert">
      <div class="container">
        <div class="alert-icon">
          <i class="now-ui-icons ui-2_like"></i>
        </div>
        <strong>Mensaje Enviado</strong> Gracias por contactarse con nosotros. Un agente se pondra contacto con usted.
        <button
          type="button"
          class="close"
          @click="dismissAlert"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">
            <i class="now-ui-icons ui-1_simple-remove"></i>
          </span>
        </button>
      </div>
    </div>
    <div v-if="!isErrorHidden" class="alert alert-danger" role="alert">
      <div class="container">
        <div class="alert-icon">
          <i class="now-ui-icons objects_support-17"></i>
        </div>
        <strong>Mensaje NO Enviado</strong>
        Por favor intente mas tarde, momentaneamente no podemos enviar su consulta.
        <button
          type="button"
          class="close"
          @click="dismissAlert"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">
            <i class="now-ui-icons ui-1_simple-remove"></i>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, InfoSection, FormGroupInput } from '@/components';
import { API_KEY } from '@/constants';
import Vue from 'vue';
import { Select, Option } from 'element-ui';
import * as miscService from '../../services/MiscService';
import { debug } from 'util';
import VueRecaptcha from 'vue-recaptcha';

export default {
  inject: ['$validator'],
  name: 'home',
  bodyClass: 'home',
  components: {
    'vue-recaptcha': VueRecaptcha,
    InfoSection,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Select.name]: Select,
    [Option.name]: Option
  },
  async mounted() {
    this.form.condicionId = 2;
    this.condicionContactoList = await miscService.getAllCondicionContacto();
  },
  data() {
    return {
      verified: false,
      captchaKey: process.env.VUE_APP_CAPTCHA_KEY,
      errorForm: '',
      condicionContactoList: [],
      form: {
        condicionId: 2,
        nombre: '',
        email: '',
        telefono: '',
        empresa: '',
        mensaje: ''
      },
      isSuccessHidden: true,
      isErrorHidden: true
    };
  },
  methods: {
    async sendForm() {
      var self = this;
      if (self.verified) {
        this.errors = [];
        this.$validator.validateAll().then(async isValid => {
          if (!isValid) {
            self.$noty.error('Corrija los errores antes de continuar.');
          } else {
            await self.enviar();
          }
        });
      } else {
        self.$noty.error('Debe resolver el captcha');
      }
    },
    dismissAlert() {
      this.isSuccessHidden = true;
      this.isErrorHidden = true;
    },
    async enviar() {
      var self = this;
      var selectedLabel = this.$refs.condicionContactoSelect.selectedLabel;
      this.form.condicionTexto = selectedLabel;
      this.form.tipoFormulario = 'Contacto';
      var result = await this.$zaiq()
        .post('contacto/create', this.form)
        .then(success => {
          self.cleanForm();
          self.$noty.success('Se ha enviado correctamente el mensaje.');
        })
        .catch(error =>
          self.$noty.error('Ha ocurrido un error intentando enviar el mensaje.')
        );
    },
    cleanForm() {
      this.form = {
        condicionId: 2,
        nombre: '',
        email: '',
        telefono: '',
        empresa: '',
        mensaje: ''
      };
      this.$validator.reset();
    },
    onVerify: function(response) {
      this.verified = true;
    }
  }
};
</script>
<style scoped>
.form-group >>> .el-input__inner[readonly] {
  background-color: #888888 !important;
}

.error-message {
  display: block;
  font-size: 0.75em;
  margin-bottom: 0.5em;
  color: #f22435;
}
</style>
